
<!-- Reusable upload-on-select status indicator (FR1/FR5). Pass the control name as context. -->
<ng-template #uploadStatus let-c>
  <div class="mt-1" *ngIf="uploadState[c]">
    <span *ngIf="uploadState[c] === 'uploading'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Uploading…</span>
    <span *ngIf="uploadState[c] === 'uploaded'" class="text-success small"><i class="fa fa-check-circle"></i> Uploaded</span>
    <span *ngIf="uploadState[c] === 'error'" class="text-danger small"><i class="fa fa-times-circle"></i> {{ uploadError[c] || 'Upload failed — please re-select the file.' }}</span>
  </div>
</ng-template>

<div class="row" *ngIf="f.isdataavailable">
  <h1> Data not available or this case is not assigned for to view</h1>
</div>
  <div class="row" *ngIf="!f.isdataavailable">

    <form *ngIf="formResetToggle" class="login" name="loginForm"
          [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>

      <span>Please provide the following information for Smart Circle to use in preparing your Distribution and Services Agreement and Statement(s) of Work.</span>
      <!-- general form elements disabled -->
      <div class="row">
        <div class="col-sm-4">
          <div class="form-check mb-3">
            <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

            <label for="acceptTerms" class="form-check-label">US</label><br />
            <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
            <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
            <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
          </div>
        </div>

      </div>


      <div class="card card-secondary">
        <div class="card-header">
          <h3 class="card-title">Legal Information</h3>

          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">


          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Full Legal Company Name <code>*</code></label>
                <input type="text" formControlName="Full_Legal_Company_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Full_Legal_Company_Name"
                       [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && !f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                       appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
             'text-danger': f.Full_Legal_Company_Name.errors?.maxlength,
             'text-muted': !f.Full_Legal_Company_Name.errors?.maxlength
           }">

                  {{ icdForm.get('Full_Legal_Company_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Full_Legal_Company_Name }}

                </div>
                <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                  <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  <div *ngIf="f.Full_Legal_Company_Name.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Full_Legal_Company_Name }} characters allowed
                  </div>
                </div>

              </div>




            </div>
            <div class="col-sm-4">
              <div class="form-group">

                <div class="col-md-12">

                  <label class="col-form-label  col-md-12" for="login-Date_of_Incorporation">Date of Incorporation <code>*</code></label>
                  <div class="input-group date" id="reservationdate" data-target-input="nearest">
                    <input type="text" formControlName="Date_of_Incorporation" data-target="#reservationdate" autocomplete="off"
                           id="Date_of_Incorporation" placeholder="Select Date of Incorporation"
                           class="form-control" [ngClass]="{'is-valid': submitted && f.Date_of_Incorporation.valid, 'is-invalid' : submitted && !f.Date_of_Incorporation.valid}"
                           required
                           appAiHint="Date of Incorporation" [aiHintForm]="icdForm"
                           />
                    <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                      <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                    </div>
                    <div *ngIf="submitted && f.Date_of_Incorporation.errors" class="invalid-feedback">
                      <div *ngIf="f.Date_of_Incorporation.errors.required">Date of Incorporation is required</div>
                      <div *ngIf="f.Date_of_Incorporation.errors.pattern">Date of Incorporation must be a valid date in the format MM-DD-YYYY</div>
                    </div>


                  </div>


                </div>

              </div>
            </div>
            <!--<div class="col-sm-4">

              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Years_in_Business">Years in Business<code>*</code></label>
                <input type="text" formControlName="Years_in_Business" class="form-control"
                       [ngClass]="{'is-valid': f.Years_in_Business.valid, 'is-invalid' : submitted && !f.Years_in_Business.valid}" placeholder="Enter Years in Business"
                       appAiHint="Years in Business" [aiHintForm]="icdForm" />
                <div *ngIf="submitted && f.Years_in_Business.errors" class="invalid-feedback">
                  <div *ngIf="f.Years_in_Business.errors.required">Years in Business is required</div>
                  <div *ngIf="f.Years_in_Business.errors.pattern">Only numbers only allowed</div>
                </div>




              </div>
            </div>-->

            <div class="col-sm-4">

              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N. # (Tax ID)/Business # <code>*</code></label>
                <input type="text" formControlName="Tax_ID" class="form-control" [attr.maxlength]="fieldMaxLengths.Tax_ID"
                       appFeinMask [feinCountry]="selectedCountry"
                       [ngClass]="{'is-valid': f.Tax_ID.valid, 'is-invalid' : submitted && !f.Tax_ID.valid}" placeholder="Enter  F.E.I.N. # (Tax ID)/Business" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                     'text-danger' : f.Tax_ID.errors?.maxlength,
                     'text-muted' : !f.Tax_ID.errors?.maxlength
                      }">
                  {{ icdForm.get('Tax_ID')?.value?.length || 0 }}/{{ fieldMaxLengths.Tax_ID }}
                </div>
                <div *ngIf="submitted && f.Tax_ID.errors" class="invalid-feedback">
                  <div *ngIf="f.Tax_ID.errors.required">F.E.I.N. # (Tax ID)/Business #  is required</div>
                  <div *ngIf="f.Tax_ID.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Tax_ID }} characters allowed
                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

              <div class="form-group">

                <label class="col-form-label  col-md-12" for="State_of_Incorporation">State of Incorporation <code>*</code></label>
                <ng-select [searchable]="true" formControlName="State_of_Incorporation" [ngClass]="{'is-valid': f.State_of_Incorporation.valid, 'is-invalid' : submitted && !f.State_of_Incorporation.valid}">
                  <ng-option *ngFor="let o of ddlUSStates"
                             [value]="o.value">
                    {{ o.name }}
                  </ng-option>
                </ng-select>
                <div *ngIf="submitted && f.State_of_Incorporation.errors" class="invalid-feedback d-block">
                  <div *ngIf="f.State_of_Incorporation.errors.required">State of Incorporation is required</div>
                </div>

              </div>
            </div>


            <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

              <div class="form-group">

                <label class="col-form-label  col-md-12" for="Provinence_of_Incorporation">Province of Incorporation <code>*</code></label>
                <ng-select [searchable]="true" formControlName="Provinence_of_Incorporation" [ngClass]="{'is-valid': f.Provinence_of_Incorporation.valid, 'is-invalid' : submitted && !f.Provinence_of_Incorporation.valid}">
                  <ng-option *ngFor="let o of ddlCAProvinence"
                             [value]="o.value">
                    {{ o.name }}
                  </ng-option>
                </ng-select>
                <div *ngIf="submitted && f.Provinence_of_Incorporation.errors" class="invalid-feedback d-block">
                  <div *ngIf="f.Provinence_of_Incorporation.errors.required">Province Incorporation is required</div>
                </div>

              </div>
            </div>



          </div>

        </div>

      </div>



      <div class="card card-secondary">
        <div class="card-header">
          <h3 class="card-title">Company Information (For Official Notices)</h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <!-- /.card-header -->
        <div class="card-body">
          <div class="row">


            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Company_Address1">Business Address 1<code>*</code></label>
                <input type="text" formControlName="Company_Address1" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Address1"
                       [ngClass]="{'is-valid': f.Company_Address1.valid, 'is-invalid' : submitted && !f.Company_Address1.valid}" placeholder="Enter Address 1"
                       appAiHint="Company Address 1" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                      'text-danger' : f.Company_Address1.errors?.maxlength,
                      'text-muted' : !f.Company_Address1.errors?.maxlength
                        }">
                  {{ icdForm.get('Company_Address1')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Address1 }}
                </div>
                <div *ngIf="submitted && f.Company_Address1.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_Address1.errors.required">Address 1  is required</div>
                  <div *ngIf="f.Company_Address1.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Company_Address1 }} characters allowed

                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Company_Address2">Address 2(e.g. Suite 100)</label>
                <input type="text" formControlName="Company_Address2" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Address2"
                       placeholder="Enter Address 2 "
                       appAiHint="Company Address 2" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                        'text-danger' : f.Company_Address2.errors?.maxlength,
                        'text-muted' : !f.Company_Address2.errors?.maxlength
                          }">
                  {{ icdForm.get('Company_Address2')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Address2 }}
                </div>
                <div *ngIf="submitted && f.Company_Address2.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_Address2.errors.required">Address 2  is required</div>
                  <div *ngIf="f.Company_Address2.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Company_Address2 }} characters allowed

                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Company_City">City <code>*</code></label>
                <input type="text" formControlName="Company_City" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_City"
                       [ngClass]="{'is-valid': f.Company_City.valid, 'is-invalid' : submitted && !f.Company_City.valid}" placeholder="Enter  City"
                       appAiHint="Company City" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                        'text-danger' : f.Company_City.errors?.maxlength,
                        'text-muted' : !f.Company_City.errors?.maxlength
                          }">
                  {{ icdForm.get('Company_City')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_City }}
                </div>
                <div *ngIf="submitted && f.Company_City.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_City.errors.required">City is required</div>
                  <div *ngIf="f.Company_City.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Company_City }} characters allowed

                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4" *ngIf="selectedCountry == 'US'">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Company_Country">County <code>*</code></label>
                <input type="text" formControlName="Company_Country" class="form-control"
                       [ngClass]="{'is-valid': f.Company_Country.valid, 'is-invalid' : submitted && !f.Company_Country.valid}" placeholder="Enter County"
                       appAiHint="Company County" [aiHintForm]="icdForm" />
                <div *ngIf="submitted && f.Company_Country.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_Country.errors.required">County is required</div>
                </div>

              </div>
            </div>
            <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

              <div class="form-group">

                <div class="col-md-12">
                  <label class="form-label">State  <code>*</code></label>

                  <ng-select [searchable]="true" formControlName="Company_State" [ngClass]="{'is-valid': f.Company_State.valid, 'is-invalid' : submitted && !f.Company_State.valid}">
                    <ng-option *ngFor="let o of ddlUSStates"
                               [value]="o.value">
                      {{ o.name }}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="submitted && f.Company_State.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_State.errors.required">State is required</div>
                  </div>


                </div>




              </div>
            </div>


            <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

              <div class="form-group">

                <div class="col-md-12">
                  <label class="form-label">Province <code>*</code></label>

                  <ng-select [searchable]="true" formControlName="Company_Province" [ngClass]="{'is-valid': f.Company_Province.valid, 'is-invalid' : submitted && !f.Company_Province.valid}">
                    <ng-option *ngFor="let o of ddlCAProvinence"
                               [value]="o.value">
                      {{ o.name }}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="submitted && f.Company_Province.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Province.errors.required">Province  is required</div>
                  </div>


                </div>




              </div>
            </div>



            <div class="col-sm-4">
              <div class="form-group">
                <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
                <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
                <input type="text" formControlName="Company_Postal_Code" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Postal_Code"
                       [ngClass]="{'is-valid': f.Company_Postal_Code.valid, 'is-invalid' : submitted && !f.Company_Postal_Code.valid}" placeholder="Enter  postal Code (Zip)"
                       appAiHint="Company Postal Code" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                          'text-danger' : f.Company_Postal_Code.errors?.maxlength,
                          'text-muted' : !f.Company_Postal_Code.errors?.maxlength
                            }">
                  {{ icdForm.get('Company_Postal_Code')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Postal_Code }}
                </div>
                <div *ngIf="submitted && f.Company_Postal_Code.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_Postal_Code.errors.required">Postal Code  is required</div>
                  <div *ngIf="f.Company_Postal_Code.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Company_Postal_Code }} characters allowed
                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Company_Office_Phone">Office Phone <code>*</code></label>
                <input type="text" formControlName="Company_Office_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'tenDigit'" [attr.maxlength]="fieldMaxLengths.Company_Office_Phone"
                       [ngClass]="{'is-valid': f.Company_Office_Phone.valid, 'is-invalid' : submitted && !f.Tax_ID.valid}"
                       placeholder="Enter  Office Phone"
                       appAiHint="Company Office Phone" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                            'text-danger' : f.Company_Office_Phone.errors?.maxlength,
                            'text-muted' : !f.Company_Office_Phone.errors?.maxlength
                              }">
                  {{ icdForm.get('Company_Office_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Office_Phone }}
                </div>
                <div *ngIf="submitted && f.Company_Office_Phone.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_Office_Phone.errors.required">Office Phone  is required</div>
                  <div *ngIf="f.Company_Office_Phone.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Company_Office_Phone }} characters allowed
                  </div>

                </div>

              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Company_Business_Email">Business Email <code>*</code></label>
                <input type="text" formControlName="Company_Business_Email" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Business_Email"
                       [ngClass]="{'is-valid': f.Company_Business_Email.valid, 'is-invalid' : submitted && !f.Company_Business_Email.valid}"
                       placeholder="Enter Business Email"
                       appAiHint="Company Business Email" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                              'text-danger' : f.Company_Business_Email.errors?.maxlength,
                              'text-muted' : !f.Company_Business_Email.errors?.maxlength
                                }">
                  {{ icdForm.get('Company_Business_Email')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Business_Email }}
                </div>
                <div *ngIf="submitted && f.Company_Business_Email.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_Business_Email.errors.required">Business Email  is required</div>
                  <div *ngIf="f.Company_Business_Email.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Company_Business_Email }} characters allowed
                  </div>
                </div>

              </div>
            </div>

          </div>


          <!-- /.card-body -->
        </div>
      </div>


      <div class="card card-secondary">
        <div class="card-header">
          <h3 class="card-title">Owner's Information</h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_First_Name">Owner's Legal First Name <code>*</code></label>
                <input type="text" formControlName="Owner_First_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_First_Name"
                       [ngClass]="{'is-valid': f.Owner_First_Name.valid, 'is-invalid' : submitted && !f.Owner_First_Name.valid}"
                       placeholder="Enter  Owner Legal First Name"
                       appAiHint="Owner First Name" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                        'text-danger' : f.Owner_First_Name.errors?.maxlength,
                        'text-muted' : !f.Owner_First_Name.errors?.maxlength
                          }">
                  {{ icdForm.get('Owner_First_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_First_Name }}
                </div>
                <div *ngIf="submitted && f.Owner_First_Name.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_First_Name.errors.required">Owner First Name is required</div>
                  <div *ngIf="f.Owner_First_Name.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_First_Name }} characters allowed

                  </div>
                </div>

                </div>
            </div>
            <div class="col-sm-4">


              <label class="col-form-label  col-md-12" for="login-Owner_Middle_Name">Owner's Legal Middle Name <code *ngIf="!noMiddleName">*</code></label>
              <div class="custom-control custom-switch custom-switch-on-success col-md-12 mb-2">
                <input type="checkbox" class="custom-control-input" id="noMiddleNameCheckbox" [checked]="noMiddleName" (change)="toggleMiddleName($event)" />
                <label class="custom-control-label" for="noMiddleNameCheckbox">No Middle Name</label>
              </div>
              <input type="text" formControlName="Owner_Middle_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Middle_Name"
                     [ngClass]="{'is-valid':  f.Owner_Middle_Name.valid, 'is-invalid' :submitted && !f.Owner_Middle_Name.valid}" placeholder="Enter Owner Legal Middle Name"
                     appAiHint="Owner Middle Name" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
                      'text-danger' : f.Owner_Middle_Name.errors?.maxlength,
                      'text-muted' : !f.Owner_Middle_Name.errors?.maxlength
                        }">
                {{ icdForm.get('Owner_Middle_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Middle_Name }}
              </div>
              <div *ngIf="submitted && f.Owner_Middle_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Middle_Name.errors.required">Middle Name is required</div>
                <div *ngIf="f.Owner_Middle_Name.errors.maxlength">
                  Maximum {{ fieldMaxLengths.Owner_Middle_Name }} characters allowed
                </div>
              </div>


            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_Last_Name">Owner's Legal Last Name <code>*</code></label>
                <input type="text" formControlName="Owner_Last_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Last_Name"
                       [ngClass]="{'is-valid': f.Owner_Last_Name.valid, 'is-invalid' : submitted && !f.Owner_Last_Name.valid}"
                       placeholder="Enter Owner Legal Last Name "
                       appAiHint="Owner Last Name" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                        'text-danger' : f.Owner_Last_Name.errors?.maxlength,
                        'text-muted' : !f.Owner_Last_Name.errors?.maxlength
                          }">
                  {{ icdForm.get('Owner_Last_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Last_Name }}
                </div>
                <div *ngIf="submitted && f.Owner_Last_Name.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Last_Name.errors.required">Owner Last Name  is required</div>
                  <div *ngIf="f.Owner_Last_Name.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Last_Name }} characters allowed
                  </div>
                </div>

              </div>
            </div>

            <!-- Feature 10 — secondary owner (read-only, shown when populated) -->
            <div class="col-sm-4" *ngIf="secondaryOwner">
              <div class="form-group">
                <label class="col-form-label col-md-12">Secondary Owner</label>
                <input type="text" class="form-control" [value]="secondaryOwner" disabled />
              </div>
            </div>

            <div class="row">

              <div class="form-check mb-3">
                Does Owner have a different preferred name ?  <code>*</code><br />

                <input type="radio" value="Yes" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ" (change)="onIsPreferChange('Yes')" class="form-check-input" />
                <label for="acceptTerms" class="form-check-label">Yes</label><br />
                <input type="radio" value="No" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ" (change)="onIsPreferChange('No')" class="form-check-input" />
                <label for="acceptTerms" class="form-check-label">No </label>

              </div>

              <div class="col-sm-4" *ngIf="IsPref_Differ">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Owner_Preferred_First_Name">Preferred First Name <code>*</code></label>
                  <input type="text" formControlName="Owner_Preferred_First_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Preferred_First_Name"
                         placeholder="Enter Preferred First Name"
                         appAiHint="Owner Preferred First Name" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{
        'text-danger' : f.Owner_Preferred_First_Name.errors?.maxlength,
        'text-muted' : !f.Owner_Preferred_First_Name.errors?.maxlength
          }">
                    {{ icdForm.get('Owner_Preferred_First_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Preferred_First_Name }}
                  </div>
                  <div *ngIf="submitted && f.Owner_Preferred_First_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Owner_Preferred_First_Name.errors.required">Preferred First Name is required</div>
                    <div *ngIf="f.Owner_Preferred_First_Name.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Owner_Preferred_First_Name }} characters allowed
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4" *ngIf="IsPref_Differ">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Owner_Preferred_Last_Name">Preferred Last Name <code>*</code></label>
                  <input type="text" formControlName="Owner_Preferred_Last_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Preferred_Last_Name"
                         placeholder="Enter Preferred Last Name"
                         appAiHint="Owner Preferred Last Name" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{
                       'text-danger' : f.Owner_Preferred_Last_Name.errors?.maxlength,
                        'text-muted' : !f.Owner_Preferred_Last_Name.errors?.maxlength
                          }">
                    {{ icdForm.get('Owner_Preferred_Last_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Preferred_Last_Name }}
                  </div>
                  <div *ngIf="submitted && f.Owner_Preferred_Last_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Owner_Preferred_Last_Name.errors.required">Preferred Last Name is required</div>
                    <div *ngIf="f.Owner_Preferred_Last_Name.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Owner_Preferred_Last_Name }} characters allowed
                    </div>
                  </div>
                </div>
              </div>





            </div>


            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label col-md-12" for="login-SSN-SIN">
                  {{ isUS ? 'SSN' : 'SIN' }} <code>*</code>
                </label>
                <!-- Show masked value when not focused, and full value when editing -->
                <input type="text"
                       formControlName="SSN_SIN"
                       class="form-control"
                       [ngClass]="{'is-valid': f.SSN_SIN?.valid, 'is-invalid' : submitted && f.SSN_SIN?.invalid}"
                       placeholder="{{ isUS ? 'XXX-XX-XXXX' : 'XXX-XXX-XXX' }}"
                       (focus)="onFocus()"
                       (blur)="onBlur()"
                       [value]="displayValue"
                       (input)="onInputChange($event.target.value)"
                       appAiHint="SSN / SIN" [aiHintForm]="icdForm" />
                <div *ngIf="submitted && f.SSN_SIN?.errors" class="invalid-feedback">
                  <div *ngIf="f.SSN_SIN.errors.required">SSN/SIN is required</div>
                  <div *ngIf="f.SSN_SIN.errors.pattern">Invalid {{ isUS ? 'SSN' : 'SIN' }} format</div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_Address1">Home Address 1<code>*</code></label>
                <input type="text" formControlName="Owner_Address1" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Address1"
                       [ngClass]="{'is-valid': f.Owner_Address1.valid, 'is-invalid' : submitted && !f.Owner_Address1.valid}" placeholder="Enter  Home Address 1"
                       appAiHint="Owner Address 1" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                        'text-danger' : f.Owner_Address1.errors?.maxlength,
                        'text-muted' : !f.Owner_Address1.errors?.maxlength
                          }">
                  {{ icdForm.get('Owner_Address1')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Address1 }}
                </div>
                <div *ngIf="submitted && f.Owner_Address1.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Address1.errors.required">Home Address 1  is required</div>
                  <div *ngIf="f.Owner_Address1.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Address1 }} characters allowed
                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_Address2">Address 2 (e.g. Suite 100)</label>
                <input type="text" formControlName="Owner_Address2" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Address2"
                       placeholder="Enter Address 2 (e.g. Suite 100)"
                       appAiHint="Owner Address 2" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                          'text-danger' : f.Owner_Address2.errors?.maxlength,
                          'text-muted' : !f.Owner_Address2.errors?.maxlength
                            }">
                  {{ icdForm.get('Owner_Address2')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Address2 }}
                </div>
                <div *ngIf="submitted && f.Owner_Address2.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Address2.errors.required">Address 2 (e.g. Suite 100)  is required</div>
                  <div *ngIf="f.Owner_Address2.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Address2 }} characters allowed
                  </div>
                </div>

              </div>
            </div>



            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_City">City <code>*</code></label>
                <input type="text" formControlName="Owner_City" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_City"
                       [ngClass]="{'is-valid': f.Owner_City.valid, 'is-invalid' : submitted && !f.Owner_City.valid}" placeholder="Enter City"
                       appAiHint="Owner City" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                            'text-danger' : f.Owner_City.errors?.maxlength,
                            'text-muted' : !f.Owner_City.errors?.maxlength
                              }">
                  {{ icdForm.get('Owner_City')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_City }}
                </div>
                <div *ngIf="submitted && f.Owner_City.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_City.errors.required">City  is required</div>
                  <div *ngIf="f.Owner_City.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_City }} characters allowed
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4 hide" *ngIf="selectedCountry == 'US'">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_Country">County <code>*</code></label>
                <input type="text" formControlName="Owner_Country" class="form-control"
                       [ngClass]="{'is-valid': f.Owner_Country.valid, 'is-invalid' : submitted && !f.Owner_Country.valid}" placeholder="Enter County"
                       />
                <div *ngIf="submitted && f.Owner_Country.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Country.errors.required">Country is required</div>
                </div>

              </div>
            </div>
            <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

              <div class="form-group">

                <div class="col-md-12">
                  <label class="form-label">State  <code>*</code></label>


                  <ng-select [searchable]="true" formControlName="Owner_State" [ngClass]="{'is-valid': f.Owner_State.valid, 'is-invalid' : submitted && !f.Owner_State.valid}">
                    <ng-option *ngFor="let o of ddlUSStates"
                               [value]="o.value">
                      {{ o.name }}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="submitted && f.Owner_State.errors" class="invalid-feedback">
                    <div *ngIf="f.Owner_State.errors.required">State is required</div>
                  </div>


                </div>




              </div>
            </div>


            <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

              <div class="form-group">

                <div class="col-md-12">
                  <label class="form-label">Province <code>*</code></label>

                  <ng-select [searchable]="true" formControlName="Owner_Province" [ngClass]="{'is-valid': f.Owner_Province.valid, 'is-invalid' : submitted && !f.Owner_Province.valid}">
                    <ng-option *ngFor="let o of ddlCAProvinence"
                               [value]="o.value">
                      {{ o.name }}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="submitted && f.Owner_Province.errors" class="invalid-feedback">
                    <div *ngIf="f.Owner_Province.errors.required">Province  is required</div>
                  </div>


                </div>




              </div>
            </div>


            <div class="col-sm-4">
              <div class="form-group">
                <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
                <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
                <input type="text" formControlName="Owner_Postal_Code" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Postal_Code"
                       [ngClass]="{'is-valid': f.Owner_Postal_Code.valid, 'is-invalid' : submitted && !f.Tax_ID.valid}" placeholder="Enter  Postal Code (Zip)"
                       appAiHint="Owner Postal Code" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                              'text-danger' : f.Owner_Postal_Code.errors?.maxlength,
                              'text-muted' : !f.Owner_Postal_Code.errors?.maxlength
                                }">
                  {{ icdForm.get('Owner_Postal_Code')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Postal_Code }}
                </div>
                <div *ngIf="submitted && f.Owner_Postal_Code.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Postal_Code.errors.required">Postal Code (Zip)  is required</div>
                  <div *ngIf="f.Owner_Postal_Code.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Postal_Code }} characters allowed
                  </div>
                </div>

              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_Mobile_Phone">Mobile Phone <code>*</code></label>
                <input type="text" formControlName="Owner_Mobile_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'elevenDigit'" [attr.maxlength]="fieldMaxLengths.Owner_Mobile_Phone"
                       [ngClass]="{'is-valid': f.Owner_Mobile_Phone.valid, 'is-invalid' : submitted && !f.Owner_Mobile_Phone.valid}" placeholder="X-XXX-XXX-XXXX"
                       appAiHint="Owner Mobile Phone" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                                'text-danger' : f.Owner_Mobile_Phone.errors?.maxlength,
                                'text-muted' : !f.Owner_Mobile_Phone.errors?.maxlength
                                  }">
                  {{ icdForm.get('Owner_Mobile_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Mobile_Phone }}
                </div>
                <div *ngIf="submitted && f.Owner_Mobile_Phone.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Mobile_Phone.errors.required">Mobile Phone   is required</div>
                  <div *ngIf="f.Owner_Mobile_Phone.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Mobile_Phone }} characters allowed
                  </div>
                  <div>Mobile phone must be 11 digits starting with 1 (country code).</div>
                </div>

              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Owner_Home_Phone">Home Phone</label>
                <input type="text" formControlName="Owner_Home_Phone" class="form-control" appPhoneNumberMask [phoneNumberFormat]="'tenDigit'" [attr.maxlength]="fieldMaxLengths.Owner_Home_Phone"
                       placeholder="XXX-XXX-XXXX"
                       appAiHint="Owner Home Phone" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                                  'text-danger' : f.Owner_Home_Phone.errors?.maxlength,
                                  'text-muted' : !f.Owner_Home_Phone.errors?.maxlength
                                    }">
                  {{ icdForm.get('Owner_Home_Phone')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Home_Phone }}
                </div>
                <div *ngIf="submitted && f.Owner_Home_Phone.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Home_Phone.errors.required">Home Phone  is required</div>
                  <div *ngIf="f.Owner_Home_Phone.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Home_Phone }} characters allowed
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4 hide">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Owner's Email <code>*</code></label>
                <input type="text" formControlName="Owner_Email" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Email"
                       [ngClass]="{'is-valid': f.Owner_Email.valid, 'is-invalid' : submitted && !f.Owner_Email.valid}" placeholder="Enter  Owner's Email"
                       appAiHint="Owner Email" [aiHintForm]="icdForm" />
                <div class="text-right small mt-1"
                     [ngClass]="{
                                  'text-danger' : f.Owner_Email.errors?.maxlength,
                                  'text-muted' : !f.Owner_Email.errors?.maxlength
                                    }">
                  {{ icdForm.get('Owner_Email')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Email }}
                </div>
                <div *ngIf="submitted && f.Owner_Email.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Email.errors.required">Owner's Email is required</div>
                  <div *ngIf="f.Owner_Email.errors.maxlength">
                    Maximum {{ fieldMaxLengths.Owner_Email }} characters allowed
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label col-md-12" for="login-Owner_Perc">Ownership Percentage <code>*</code></label>
                <input type="number"
                       step="any"
                       formControlName="Owner_Perc"
                       class="form-control"
                       [ngClass]="{'is-valid': f.Owner_Perc.valid,        'is-invalid': submitted && !f.Owner_Perc.valid  }"
                       placeholder="Enter Ownership Percentage (e.g. 33.33)" />
                <div *ngIf="submitted && f.Owner_Perc.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Perc.errors.required">
                    Ownership Percentage is required
                  </div>
                  <div *ngIf="f.Owner_Perc.errors.min">
                    Ownership Percentage must be at least 1
                  </div>
                  <div *ngIf="f.Owner_Perc.errors.max">
                    Ownership Percentage cannot exceed 100
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.card-body -->


        </div>
      </div>

      <div class="card card-secondary">
        <div class="card-header">
          <h3 class="card-title">HUB Information</h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
                <div class="col-md-12">
                  <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                         class="form-control"
                         appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Number">Hub Number <code>*</code></label>
                <div class="col-md-12">
                  <input type="text" formControlName="HUB_Manager_Contact_Number" id="login-HUB_Manager_Contact_Number" name="HUB_Manager_Contact_Number" placeholder="Enter Hub Number"
                         autocomplete="current-Owner_Last_Name" class="form-control"
                         appAiHint="HUB Manager Contact Number" [aiHintForm]="icdForm" />

                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Email">Hub Email <code>*</code></label>
                <div class="col-md-12">
                  <input type="text" formControlName="HUB_Manager_Contact_Email" id="login-HUB_Manager_Contact_Email" name="HUB_Manager_Contact_Email" placeholder="Enter Hub Email" autocomplete="current-HUB_Manager_Contact_Email"
                         class="form-control"
                         appAiHint="HUB Manager Contact Email" [aiHintForm]="icdForm" />

                </div>
              </div>
            </div>

          </div>

          <!-- /.card-body -->
        </div>
      </div>

      <div class="card card-secondary">
        <div class="card-header">
          <h3 class="card-title">
            Additional Information
          </h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                <div class="col-md-12">
                  <!--<select formControlName="Promoting_Owner" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.Promoting_Owner.errors }" (change)="onCheckboxPo($event.target)">
                    <option value="" disabled>Please Select</option>

                    <option *ngFor="let c of PO_namesData" [ngValue]="c.ownerName" [attr.data-company]="c.name">{{ c.ownerNameCompany }}</option>
                  </select>-->
                  <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                    <ng-option *ngFor="let o of PO_namesData"
                               [value]="o.id">
                      {{ o.ownerNameCompany }}
                    </ng-option>
                  </ng-select>

                  <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                    <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner's Company<code>*</code></label>
                <div class="col-md-12">
                  <input type="text" formControlName="Promoting_Owner_Company" class="form-control"
                         placeholder="Enter Promoting Owner Company"
                         appAiHint="Promoting Owner Company" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Promoting_Owner_Company.errors" class="invalid-feedback">
                    <div *ngIf="f.Promoting_Owner_Company.errors.required">Promoting  Company is required</div>
                  </div>
                </div>
              </div>


            </div>
            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                <div class="col-md-12">



                  <ng-select [searchable]="true" formControlName="Regional_Consultant"
                             (change)="onCheckboxRC($event)">
                    <ng-option *ngFor="let o of RC_namesData"
                               [value]="o.id">
                      {{ o.ownerNameCompany }}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                    <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant's Company</label>
                <div class="col-md-12">
                  <input type="text" formControlName="Regional_Consultant_Company" class="form-control"
                         placeholder="Enter Regional Consultant Company"
                         appAiHint="Regional Consultant Company" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Regional_Consultant_Company.errors" class="invalid-feedback">
                    <div *ngIf="f.Regional_Consultant_Company.errors.required">Regional Consultant Company is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                <div class="col-md-12">


                  <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                             (change)="onCheckboxNC($event)">
                    <ng-option *ngFor="let o of NC_namesData"
                               [value]="o.id">
                      {{ o.ownerNameCompany }}
                    </ng-option>
                  </ng-select>

                  <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                    <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant's Company<code>*</code></label>
                <div class="col-md-12">
                  <input type="text" formControlName="National_Consultant_Company" class="form-control"
                         placeholder="Enter National Consultant Company"
                         appAiHint="National Consultant Company" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.National_Consultant_Company.errors" class="invalid-feedback">
                    <div *ngIf="f.National_Consultant_Company.errors.required">National Consultant Company is required</div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Company_Website">Company Website</label>
                <div class="col-md-12">
                  <input type="text" formControlName="Company_Website" class="form-control" [attr.maxlength]="fieldMaxLengths.Company_Website"
                         placeholder="Enter Company Website"
                         appAiHint="Company Website" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{
                                    'text-danger' : f.Company_Website.errors?.maxlength,
                                    'text-muted' : !f.Company_Website.errors?.maxlength
                                      }">
                    {{ icdForm.get('Company_Website')?.value?.length || 0 }}/{{ fieldMaxLengths.Company_Website }}
                  </div>
                  <div *ngIf="submitted && f.Company_Website.errors" class="invalid-feedback">
                    <div *ngIf="f.Company_Website.errors.required">Company Website is required</div>
                    <div *ngIf="f.Company_Website.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Company_Website }} characters allowed
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4" style="display:none;">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Payroll_Provider">Payroll Provider </label>
                <div class="col-md-12">
                  <ng-select [searchable]="true" formControlName="Payroll_Provider" 
                             [ngClass]="{ 'is-invalid': submitted && f.Payroll_Provider.errors }"
                             (change)="onPayrollProviderChange($event)">
                    <ng-option value="">Please Select</ng-option>
                    <ng-option value="HerbJoy">HerbJoy</ng-option>
                    <ng-option value="Holly Long">Holly Long</ng-option>
                    <ng-option value="Nathan Arnold">Nathan Arnold</ng-option>
                    <ng-option value="Nathan Porter">Nathan Porter</ng-option>
                    <ng-option value="Other (Not Listed)">Other (Not Listed)</ng-option>
                  </ng-select>
                  <div *ngIf="submitted && f.Payroll_Provider.errors" class="invalid-feedback">
                    <div *ngIf="f.Payroll_Provider.errors.required">Payroll Provider is required</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4" *ngIf="isPayrollProviderOther">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Payroll_Provider_other">Payroll Provider (Not Listed) <code>*</code></label>
                <div class="col-md-12">
                  <input type="text" formControlName="Payroll_Provider_other" class="form-control" [attr.maxlength]="fieldMaxLengths.Payroll_Provider_other"
                         [ngClass]="{'is-valid': f.Payroll_Provider_other.valid, 'is-invalid' : submitted && !f.Payroll_Provider_other.valid}"
                         placeholder="Enter Payroll Provider"
                         appAiHint="Payroll Provider (Other)" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{
                                      'text-danger' : f.Payroll_Provider_other.errors?.maxlength,
                                      'text-muted' : !f.Payroll_Provider_other.errors?.maxlength
                                        }">
                    {{ icdForm.get('Payroll_Provider_other')?.value?.length || 0 }}/{{ fieldMaxLengths.Payroll_Provider_other }}
                  </div>
                  <div *ngIf="submitted && f.Payroll_Provider_other.errors" class="invalid-feedback">
                    <div *ngIf="f.Payroll_Provider_other.errors.required">Payroll Provider (Not Listed) is required</div>
                    <div *ngIf="f.Payroll_Provider_other.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Payroll_Provider_other }} characters allowed
                    </div>
                    </div>
                </div>
              </div>
            </div>

          </div>

          <!-- /.card-body -->


        </div>
      </div>

      <div class="card card-secondary ">
        <div class="card-header">
          <h3 class="card-title">  Campaign(s)  </h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <div class="row" *ngIf="selectedCountry == 'Canada'">
            <span>Select all Campaigns that apply.<code>*</code></span>
            <div class="col-md-4" *ngFor="let item of Canada_campaignData">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="item.id"
                         [disabled]="isCheckboxesDisabled" [checked]="Canada_Campaigns_selectedItems.includes(item.campaignName)"
                         [value]="item.campaignName" (change)="onCheckboxChange_Canada_Campaigns($event, item.campaignName)">
                  <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                </div>
              </div>

            </div>
            <div class="col-md-4">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" id="Canada_Campaign_Other"
                         [disabled]="isCheckboxesDisabled" [checked]="Canada_Campaigns_selectedItems.includes('Other (Not Listed)')"
                         value="Other (Not Listed)" (change)="onCheckboxChange_Canada_Campaigns($event, 'Other (Not Listed)')">
                  <label class="custom-control-label" for="Canada_Campaign_Other">Other (Not Listed)</label>
                </div>
              </div>
            </div>

          </div>

          <div class="row" *ngIf="selectedCountry == 'Canada'">
            <span>Select all  Due Diligence Campaigns that apply.</span>
            <div class="col-md-4" *ngFor="let item of Canada_campaignData_DD">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="item.id"
                         [disabled]="isCheckboxesDisabled" [checked]="Canada_Campaigns_selectedItems.includes(item.campaignName)"
                         [value]="item.campaignName" (change)="onCheckboxChange_Canada_Campaigns($event, item.campaignName)">
                  <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                </div>
              </div>

            </div>
            <span *ngIf="Canada_Campaigns_isSelectedItemsinvalid" style="color:red;">at least select one option in Campaigns</span>
          </div>
          <div class="row" *ngIf="selectedCountry == 'US'">
            <span>Select all Campaigns that apply.<code>*</code></span>
            <div class="col-md-4" *ngFor="let item of US_campaignData">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="item.id"
                         [checked]="US_Campaigns_selectedItems.includes(item.campaignName)"
                         [disabled]="isCheckboxesDisabled"
                         [value]="item.campaignName" (change)="onCheckboxChange_US_Campaigns($event, item.campaignName)">
                  <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                </div>
              </div>

            </div>
            <div class="col-md-4">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" id="US_Campaign_Other"
                         [disabled]="isCheckboxesDisabled" [checked]="US_Campaigns_selectedItems.includes('Other (Not Listed)')"
                         value="Other (Not Listed)" (change)="onCheckboxChange_US_Campaigns($event, 'Other (Not Listed)')">
                  <label class="custom-control-label" for="US_Campaign_Other">Other (Not Listed)</label>
                </div>
              </div>
            </div>

          </div>
          <div class="row" *ngIf="selectedCountry == 'US'">
            <span>Select all Due Diligence Campaigns that apply.</span>
            <div class="col-md-4" *ngFor="let item of US_campaignData_DD">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="item.id"
                         [checked]="US_Campaigns_selectedItems.includes(item.campaignName)"
                         [disabled]="isCheckboxesDisabled"
                         [value]="item.campaignName" (change)="onCheckboxChange_US_Campaigns($event, item.campaignName)">
                  <label class="custom-control-label" [for]="item.id">{{ item.campaignName }}</label>
                </div>
              </div>

            </div>
            <span *ngIf="US_Campaigns_isSelectedItemsinvalid" style="color:red;">at least select one option in Campaigns</span>
          </div>
          <div class="col-sm-4" *ngIf="isTestCampaign">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-TestCampaignNotListed">Other Campaign (Not Listed) <code>*</code></label>
              <input type="text" formControlName="TestCampaignNotListed" class="form-control" [attr.maxlength]="fieldMaxLengths.TestCampaignNotListed"
                     [ngClass]="{'is-valid': f.TestCampaignNotListed.valid, 'is-invalid' : submitted && !f.TestCampaignNotListed.valid}" placeholder="Enter Campaign Name"
                     appAiHint="Other Campaign (Not Listed)" [aiHintForm]="icdForm" />
              <div class="text-right small mt-1"
                   [ngClass]="{
                                  'text-danger' : f.TestCampaignNotListed.errors?.maxlength,
                                  'text-muted' : !f.TestCampaignNotListed.errors?.maxlength
                                    }">
                {{ icdForm.get('TestCampaignNotListed')?.value?.length || 0 }}/{{ fieldMaxLengths.TestCampaignNotListed }}
              </div>
              <div *ngIf="submitted && f.TestCampaignNotListed.errors" class="invalid-feedback">
                <div *ngIf="f.TestCampaignNotListed.errors.required">Other Campaign (Not Listed) is required</div>
                <div *ngIf="f.TestCampaignNotListed.errors.maxlength">
                  Maximum {{ fieldMaxLengths.TestCampaignNotListed }} characters allowed
                </div>
              </div>
            </div>
          </div>
          <!-- /.card-body -->


        </div>
      </div>


      <div class="card card-secondary hide" style="display:none;">
        <div class="card-header">
          <h3 class="card-title"> Retailers  </h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <div class="row" *ngIf="selectedCountry == 'US'">
            <span>Select all Retailers that apply.<code>*</code></span>

            <div class="col-md-4" *ngFor="let item of US_retailsData">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="item.id"
                         [checked]="US_Retails_selectedItems.includes(item.name)" [disabled]="isCheckboxesDisabled"
                         [value]="item.name" (change)="onCheckboxChange_US_Retails($event, item.name)">
                  <label class="custom-control-label" [for]="item.id">{{ item.name }}</label>
                </div>
              </div>

            </div>




          </div>
          <div class="row" *ngIf="selectedCountry == 'Canada'">

            <span>Select all Retailers that apply.<code>*</code></span>
            <div class="col-md-4" *ngFor="let item of Canada_retailsData">
              <div class="form-group">
                <div class="custom-control custom-switch  custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="item.id"
                         [checked]="Canada_Retails_selectedItems.includes(item.name)"
                         [disabled]="isCheckboxesDisabled"
                         [value]="item.name" (change)="onCheckboxChange_Canada_Retails($event, item.name)">
                  <label class="custom-control-label" [for]="item.id">{{ item.name }}</label>
                </div>
              </div>

            </div>
            <span *ngIf="Canada_Retails_isSelectedItemsinvalid" style="color:red;">at least select one option in Campaigns</span>


          </div>

          <!-- /.card-body -->


        </div>
      </div>

      <div class="card card-secondary" *ngIf="selectedCountry == 'US'">
        <div class="card-header">
          <h3 class="card-title">
            Documents (US) -  Provide Copies of the Following:
          </h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">


          <div class="row">



            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label " for="isInsuranceRequired">Does the ICD want Herb Joy Enterprises to refer it to an insurance broker and/or to a payroll provider ? <code>*</code></label>
                <select formControlName="isInsuranceRequired" class="form-control" (change)="ChangeIsInsurance()" [ngClass]="{ 'is-invalid': submitted && f.isInsuranceRequired.errors }">
                  <option value="" disabled>Please Select</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>

                <div *ngIf="submitted && f.isInsuranceRequired.errors" class="invalid-feedback">
                  <div *ngIf="f.isInsuranceRequired.errors.required">Is the ICD providing their own Insurance  is required</div>
                </div>
              </div>

            </div>

            <div class="col-sm-6">


              <div class="form-group">
                <label class="col-form-label col-md-12" for="login-Attach_US_Articles_of_Incorporation">Articles of Incorporation/Organization <code>*</code></label>
                <input type="file" formControlName="Attach_US_Articles_of_Incorporation"
                       [ngClass]="{'is-valid': f.Attach_US_Articles_of_Incorporation.valid && f.Attach_US_Articles_of_Incorporation.value, 'is-invalid' : submitted && !f.Attach_US_Articles_of_Incorporation.valid}" 
                       (change)="onFileSelected($event, 'Attach_US_Articles_of_Incorporation')" class="form-control" [class.is-invalid]="isInvalid('Attach_US_Articles_of_Incorporation')" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_Articles_of_Incorporation' }"></ng-container>
                <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_Articles_of_Incorporation')">
                  <div *ngIf="icdForm.get('Attach_US_Articles_of_Incorporation').errors.required">Articles of Incorporation/Organization is required</div>
                  <div *ngIf="icdForm.get('Attach_US_Articles_of_Incorporation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_US_Articles_of_Incorporation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_US_Articles_of_Incorporation']">
                  <span *ngIf="verificationState['Attach_US_Articles_of_Incorporation'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_US_Articles_of_Incorporation'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_US_Articles_of_Incorporation'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_US_Articles_of_Incorporation'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_US_Articles_of_Incorporation']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_US_Articles_of_Incorporation'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_US_Articles_of_Incorporation'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_US_Articles_of_Incorporation']">{{ issue }}</li>
                  </ul>
                </div>
                <!--<a (click)="openFile(fileId, fileName)" href="#" target="_blank">Open File</a>-->

              </div>

            </div>
            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_US_W_9">W-9<code>*</code></label>
                <input type="file" formControlName="Attach_US_W_9" class="form-control" (change)="onFileSelected($event, 'Attach_US_W_9')"
                       [ngClass]="{'is-valid': f.Attach_US_W_9.valid && f.Attach_US_W_9.value, 'is-invalid' : submitted && !f.Attach_US_W_9.valid}" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_W_9' }"></ng-container>

                <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_W_9')">
                  <div *ngIf="icdForm.get('Attach_US_W_9').errors.required">W-9 is required</div>
                  <div *ngIf="icdForm.get('Attach_US_W_9').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_US_W_9').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_US_W_9']">
                  <span *ngIf="verificationState['Attach_US_W_9'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_US_W_9'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_US_W_9'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_US_W_9'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_US_W_9']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_US_W_9'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_US_W_9'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_US_W_9']">{{ issue }}</li>
                  </ul>
                </div>

              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_US_SS4_EIN">EIN Document<code>*</code></label>
                <input type="file" formControlName="Attach_US_SS4_EIN" class="form-control" (change)="onFileSelected($event, 'Attach_US_SS4_EIN')"
                       [ngClass]="{'is-valid': f.Attach_US_SS4_EIN.valid && f.Attach_US_SS4_EIN.value, 'is-invalid' : submitted && !f.Attach_US_SS4_EIN.valid}" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_SS4_EIN' }"></ng-container>

                <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_SS4_EIN')">
                  <div *ngIf="icdForm.get('Attach_US_SS4_EIN').errors.required">EIN Document is required</div>
                  <div *ngIf="icdForm.get('Attach_US_SS4_EIN').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_US_SS4_EIN').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_US_SS4_EIN']">
                  <span *ngIf="verificationState['Attach_US_SS4_EIN'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_US_SS4_EIN'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_US_SS4_EIN'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <ul *ngIf="verificationIssues['Attach_US_SS4_EIN']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_US_SS4_EIN'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_US_SS4_EIN']">{{ issue }}</li>
                  </ul>
                </div>

              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_US_Void_Check_Bank_Account">Void Check/Bank Account Information<code>*</code></label>
                <input type="file" formControlName="Attach_US_Void_Check_Bank_Account" class="form-control" (change)="onFileSelected($event, 'Attach_US_Void_Check_Bank_Account')"
                       [ngClass]="{'is-valid': f.Attach_US_Void_Check_Bank_Account.valid && f.Attach_US_Void_Check_Bank_Account.value, 'is-invalid' : submitted && !f.Attach_US_Void_Check_Bank_Account.valid}" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_Void_Check_Bank_Account' }"></ng-container>

                <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_Void_Check_Bank_Account')">
                  <div *ngIf="icdForm.get('Attach_US_Void_Check_Bank_Account').errors.required">Void Check/Bank Account Information is required</div>
                  <div *ngIf="icdForm.get('Attach_US_Void_Check_Bank_Account').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_US_Void_Check_Bank_Account').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_US_Void_Check_Bank_Account']">
                  <span *ngIf="verificationState['Attach_US_Void_Check_Bank_Account'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_US_Void_Check_Bank_Account'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_US_Void_Check_Bank_Account'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_US_Void_Check_Bank_Account'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_US_Void_Check_Bank_Account']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_US_Void_Check_Bank_Account'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_US_Void_Check_Bank_Account'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_US_Void_Check_Bank_Account']">{{ issue }}</li>
                  </ul>
                </div>

              </div>
            </div>



            <div class="col-sm-6 hide">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_US_Node_Form">Node Form</label>
                <input type="file" formControlName="Attach_US_Node_Form" class="form-control" (change)="onFileSelected($event, 'Attach_US_Node_Form')"
                       [ngClass]="{'is-valid': f.Attach_US_Node_Form.valid && f.Attach_US_Node_Form.value, 'is-invalid' : submitted && !f.Attach_US_Node_Form.valid}" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_Node_Form' }"></ng-container>

                <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_Node_Form')">
                  <div *ngIf="icdForm.get('Attach_US_Node_Form').errors.required">Node Form is required</div>
                  <div *ngIf="icdForm.get('Attach_US_Node_Form').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_US_Node_Form').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>

              </div>
            </div>



            <div class="col-sm-6" *ngIf="isInsuranceRequired == 'false'">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_US_Certificate_of_Insurance">Certificate of Insurance</label>
                <input type="file" multiple formControlName="Attach_US_Certificate_of_Insurance" class="form-control"
                       [ngClass]="{'is-valid': f.Attach_US_Certificate_of_Insurance.valid && f.Attach_US_Certificate_of_Insurance.value, 'is-invalid' : submitted && !f.Attach_US_Certificate_of_Insurance.valid}" 
                       (change)="onFileSelected($event, 'Attach_US_Certificate_of_Insurance')" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_US_Certificate_of_Insurance' }"></ng-container>


                <div class="invalid-feedback" *ngIf="isInvalid('Attach_US_Certificate_of_Insurance')">
                  <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.required">Certificate of Insurance is required</div>
                  <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_US_Certificate_of_Insurance').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_US_Certificate_of_Insurance']">
                  <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_US_Certificate_of_Insurance']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_US_Certificate_of_Insurance'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_US_Certificate_of_Insurance']">{{ issue }}</li>
                  </ul>
                </div>


              </div>
            </div>

            <div class="col-sm-6" *ngIf="isInsuranceRequired == 'false'">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_Workers_Compensation">Proof of Workers Compensation Coverage</label>
                <input type="file" multiple formControlName="Attach_Workers_Compensation" class="form-control"
                       [ngClass]="{'is-valid': f.Attach_Workers_Compensation.valid && f.Attach_Workers_Compensation.value, 'is-invalid' : submitted && !f.Attach_Workers_Compensation.valid}" 
                       (change)="onFileSelected($event, 'Attach_Workers_Compensation')" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Workers_Compensation' }"></ng-container>


                <div class="invalid-feedback" *ngIf="isInvalid('Attach_Workers_Compensation')">
                  <div *ngIf="icdForm.get('Attach_Workers_Compensation').errors.required">Workers Compensation is required</div>
                  <div *ngIf="icdForm.get('Attach_Workers_Compensation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_Workers_Compensation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div *ngIf="verificationState['Attach_Workers_Compensation'] === 'verifying'" class="mt-1 text-muted small">
                  <i class="fas fa-spinner fa-spin"></i> Verifying document...
                </div>
                <div *ngIf="verificationState['Attach_Workers_Compensation'] === 'pass'" class="mt-1 text-success small">
                  <i class="fas fa-check-circle"></i> Document verified
                </div>
                <div *ngIf="verificationState['Attach_Workers_Compensation'] === 'warn'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification warning
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Workers_Compensation']">{{issue}}</li>
                  </ul>
                </div>
                <div *ngIf="verificationState['Attach_Workers_Compensation'] === 'warn_disabled_never_shown'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification failed
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Workers_Compensation']">{{issue}}</li>
                  </ul>
                </div>

              </div>
            </div>


          </div>



        </div>

      </div>


      <div class="card card-secondary" *ngIf="selectedCountry == 'Canada'">
        <div class="card-header">
          <h3 class="card-title">
            Documents (Canada) - Provide Copies of the Following:
          </h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">


          <div class="row">

            <div class="col-sm-6">
              <div class="form-group">
                <div class="custom-control custom-switch custom-switch-on-success">

                  <label class="col-form-label " for="isInsuranceRequired">Does the ICD want Herb Joy Enterprises to refer it to an insurance broker and/or to a payroll provider ?<code>*</code></label>
                  <select formControlName="isInsuranceRequired" class="form-control" (change)="ChangeIsInsurance()" [ngClass]="{ 'is-invalid': submitted && f.isInsuranceRequired.errors }">
                    <option value="" disabled>Please Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div *ngIf="submitted && f.isInsuranceRequired.errors" class="invalid-feedback">
                <div *ngIf="f.isInsuranceRequired.errors.required">Is the ICD providing their own Insurance  is required</div>
              </div>

            </div>

            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_Canada_Articles_of_Incorporation">Articles of Incorporation/Organization <code>*</code></label>
                <input type="file" formControlName="Attach_Canada_Articles_of_Incorporation" class="form-control" (change)="onFileSelected($event, 'Attach_Canada_Articles_of_Incorporation')"
                       [ngClass]="{'is-valid': f.Attach_Canada_Articles_of_Incorporation.valid && f.Attach_Canada_Articles_of_Incorporation.value, 'is-invalid' : submitted && !f.Attach_Canada_Articles_of_Incorporation.valid}" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Canada_Articles_of_Incorporation' }"></ng-container>


                <div class="invalid-feedback" *ngIf="isInvalid('Attach_Canada_Articles_of_Incorporation')">
                  <div *ngIf="icdForm.get('Attach_Canada_Articles_of_Incorporation').errors.required">Articles of Incorporation is required</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Articles_of_Incorporation').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Articles_of_Incorporation').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_Canada_Articles_of_Incorporation']">
                  <span *ngIf="verificationState['Attach_Canada_Articles_of_Incorporation'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_Canada_Articles_of_Incorporation'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_Canada_Articles_of_Incorporation'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_Canada_Articles_of_Incorporation'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_Canada_Articles_of_Incorporation']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_Canada_Articles_of_Incorporation'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_Canada_Articles_of_Incorporation'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_Canada_Articles_of_Incorporation']">{{ issue }}</li>
                  </ul>
                </div>

              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_Canada_Bank_Statement_or_Direct_Deposit">Bank Stamped Direct Deposit Form or Bank Account Statement <code>*</code></label>
                <input type="file" formControlName="Attach_Canada_Bank_Statement_or_Direct_Deposit" class="form-control" (change)="onFileSelected($event, 'Attach_Canada_Bank_Statement_or_Direct_Deposit')"
                       [ngClass]="{'is-valid': f.Attach_Canada_Bank_Statement_or_Direct_Deposit.valid && f.Attach_Canada_Bank_Statement_or_Direct_Deposit.value, 'is-invalid' : submitted && !f.Attach_Canada_Bank_Statement_or_Direct_Deposit.valid}" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Canada_Bank_Statement_or_Direct_Deposit' }"></ng-container>


                <div class="invalid-feedback" *ngIf="isInvalid('Attach_Canada_Bank_Statement_or_Direct_Deposit')">
                  <div *ngIf="icdForm.get('Attach_Canada_Bank_Statement_or_Direct_Deposit').errors.required">Bank Statement or Direct Deposit is required</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Bank_Statement_or_Direct_Deposit').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Bank_Statement_or_Direct_Deposit').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_Canada_Bank_Statement_or_Direct_Deposit']">
                  <span *ngIf="verificationState['Attach_Canada_Bank_Statement_or_Direct_Deposit'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_Canada_Bank_Statement_or_Direct_Deposit'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_Canada_Bank_Statement_or_Direct_Deposit'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_Canada_Bank_Statement_or_Direct_Deposit'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_Canada_Bank_Statement_or_Direct_Deposit']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_Canada_Bank_Statement_or_Direct_Deposit'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_Canada_Bank_Statement_or_Direct_Deposit'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_Canada_Bank_Statement_or_Direct_Deposit']">{{ issue }}</li>
                  </ul>
                </div>

              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_Canada_Worker_Compensation_Coverage">Proof of Worker's Compensation Coverage</label>
                <input type="file" multiple formControlName="Attach_Canada_Worker_Compensation_Coverage"
                       class="form-control"
                       [ngClass]="{'is-valid': f.Attach_Canada_Worker_Compensation_Coverage.valid && f.Attach_Canada_Worker_Compensation_Coverage.value, 'is-invalid' : submitted && !f.Attach_Canada_Worker_Compensation_Coverage.valid}" 
                       (change)="onFileSelected($event, 'Attach_Canada_Worker_Compensation_Coverage')" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Canada_Worker_Compensation_Coverage' }"></ng-container>


                <div class="invalid-feedback" *ngIf="isInvalid('Attach_Canada_Worker_Compensation_Coverage')">
                  <div *ngIf="icdForm.get('Attach_Canada_Worker_Compensation_Coverage').errors.required">Worker Compensation Coverage is required</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Worker_Compensation_Coverage').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Worker_Compensation_Coverage').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div *ngIf="verificationState['Attach_Canada_Worker_Compensation_Coverage'] === 'verifying'" class="mt-1 text-muted small">
                  <i class="fas fa-spinner fa-spin"></i> Verifying document...
                </div>
                <div *ngIf="verificationState['Attach_Canada_Worker_Compensation_Coverage'] === 'pass'" class="mt-1 text-success small">
                  <i class="fas fa-check-circle"></i> Document verified
                </div>
                <div *ngIf="verificationState['Attach_Canada_Worker_Compensation_Coverage'] === 'warn'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification warning
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Canada_Worker_Compensation_Coverage']">{{issue}}</li>
                  </ul>
                </div>
                <div *ngIf="verificationState['Attach_Canada_Worker_Compensation_Coverage'] === 'warn_disabled_never_shown'" class="mt-1 text-warning small">
                  <i class="fas fa-exclamation-triangle"></i> Verification failed
                  <ul class="mb-0 pl-3">
                    <li *ngFor="let issue of verificationIssues['Attach_Canada_Worker_Compensation_Coverage']">{{issue}}</li>
                  </ul>
                </div>

              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_Canada_Certificate_of_Insurance">Certificate(s) of Insurance (if applicable)</label>
                <input type="file" multiple formControlName="Attach_Canada_Certificate_of_Insurance"
                       class="form-control"
                       [ngClass]="{'is-valid': f.Attach_Canada_Certificate_of_Insurance.valid && f.Attach_Canada_Certificate_of_Insurance.value, 'is-invalid' : submitted && !f.Attach_Canada_Certificate_of_Insurance.valid}" 
                       (change)="onFileSelected($event, 'Attach_Canada_Certificate_of_Insurance')" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Canada_Certificate_of_Insurance' }"></ng-container>


                <div class="invalid-feedback" *ngIf="isInvalid('Attach_Canada_Certificate_of_Insurance')">
                  <div *ngIf="icdForm.get('Attach_Canada_Certificate_of_Insurance').errors.required">Certificate of Insurance is required</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Certificate_of_Insurance').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_Canada_Certificate_of_Insurance').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>
                <div class="mt-1" *ngIf="verificationState['Attach_Canada_Certificate_of_Insurance']">
                  <span *ngIf="verificationState['Attach_Canada_Certificate_of_Insurance'] === 'verifying'" class="text-secondary small"><i class="fa fa-spinner fa-spin"></i> Verifying document...</span>
                  <span *ngIf="verificationState['Attach_Canada_Certificate_of_Insurance'] === 'pass'" class="text-success small"><i class="fa fa-check-circle"></i> Document verified</span>
                  <span *ngIf="verificationState['Attach_Canada_Certificate_of_Insurance'] === 'warn'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Accepted with notes</span>
                  <span *ngIf="verificationState['Attach_Canada_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" class="text-warning small"><i class="fa fa-exclamation-triangle"></i> Verification failed</span>
                  <ul *ngIf="verificationIssues['Attach_Canada_Certificate_of_Insurance']?.length > 0" class="mt-1 mb-0 pl-3 small" [class.text-warning]="verificationState['Attach_Canada_Certificate_of_Insurance'] === 'warn_disabled_never_shown'" [class.text-warning]="verificationState['Attach_Canada_Certificate_of_Insurance'] === 'warn'" style="list-style: disc;">
                    <li *ngFor="let issue of verificationIssues['Attach_Canada_Certificate_of_Insurance']">{{ issue }}</li>
                  </ul>
                </div>

              </div>
            </div>




          </div>



        </div>

      </div>

      <div class="card card-secondary">
        <div class="card-header">
          <h3 class="card-title">
            Additional Documents
          </h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">

          <div class="row">

            <div class="col-sm-6">
              <div class="form-group">

                <label class="col-form-label  col-md-12" for="login-Attach_Additional_Document_SC">Additional Document for Smart Circle</label>
                <input type="file" formControlName="Attach_Additional_Document_SC" class="form-control" (change)="onFileSelected($event, 'Attach_Additional_Document_SC')"
                       [ngClass]="{'is-valid': f.Attach_Additional_Document_SC.valid && f.Attach_Additional_Document_SC.value}" />
                <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Attach_Additional_Document_SC' }"></ng-container>

                <div class="invalid-feedback" *ngIf="isInvalid('Attach_Additional_Document_SC')">
                  <div *ngIf="icdForm.get('Attach_Additional_Document_SC').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                  <div *ngIf="icdForm.get('Attach_Additional_Document_SC').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                </div>

              </div>
            </div>

          </div>

        </div>
        <!-- /.card-body -->
      </div>


      <div class="card card-secondary hide">
        <div class="card-header">
          <h3 class="card-title">Employee Disability Insurance</h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">

          (Mandatory disability coverage for NY and Hawaii)
          <div class="row">

            <div class="col-sm-4">

              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-Male_Emp"># of Male Employees</label>
                <div class="col-md-12">
                  <input type="text" formControlName="Male_Emp" id="login-Male_Emp" name="Male_Emp" placeholder="Enter Male Employees" autocomplete="Male_Emp"
                         class="form-control" [attr.maxlength]="fieldMaxLengths.Male_Emp"
                         appAiHint="Male Employees" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{
             'text-danger': f.Male_Emp.errors?.maxlength,
             'text-muted': !f.Male_Emp.errors?.maxlength
           }">

                    {{ icdForm.get('Male_Emp')?.value?.length || 0 }}/{{ fieldMaxLengths.Male_Emp }}

                  </div>
                  <div *ngIf="submitted && f.Male_Emp.errors"
                       class="invalid-feedback">

                    <div *ngIf="f.Male_Emp.errors.maxlength">
                      Maximum {{ fieldMaxLengths.Male_Emp }} characters allowed
                    </div>

                  </div>


                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-FeMale_Emp"> # of Female Employees </label>
                <div class="col-md-12">
                  <input type="text" formControlName="FeMale_Emp" id="login-FeMale_Emp" name="FeMale_Emp" placeholder="Enter Female Employees"
                         autocomplete="current-FeMale_Emp" class="form-control" [attr.maxlength]="fieldMaxLengths.FeMale_Emp"
                         appAiHint="Female Employees" [aiHintForm]="icdForm" />
                  <div class="text-right small mt-1"
                       [ngClass]="{
             'text-danger': f.FeMale_Emp.errors?.maxlength,
             'text-muted': !f.FeMale_Emp.errors?.maxlength
           }">

                    {{ icdForm.get('FeMale_Emp')?.value?.length || 0 }}/{{ fieldMaxLengths.FeMale_Emp }}

                  </div>
                  <div *ngIf="submitted && f.FeMale_Emp.errors"
                       class="invalid-feedback">

                    <div *ngIf="f.FeMale_Emp.errors.maxlength">
                      Maximum {{ fieldMaxLengths.FeMale_Emp }} characters allowed
                    </div>

                  </div>


                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Email">NY or HI Disability Form</label>
                <div class="col-md-12">

                  <input type="file" multiple formControlName="Disability_Form" class="form-control"
                         [ngClass]="{'is-valid': f.Disability_Form.valid && f.Disability_Form.value, 'is-invalid' : submitted && !f.Disability_Form.valid}"
                         (change)="onFileSelected($event, 'Disability_Form')" />
                  <ng-container *ngTemplateOutlet="uploadStatus; context: { $implicit: 'Disability_Form' }"></ng-container>


                  <div class="invalid-feedback" *ngIf="isInvalid('Disability_Form')">
                    <div *ngIf="icdForm.get('Disability_Form').errors.required">Disability Form is required</div>
                    <div *ngIf="icdForm.get('Disability_Form').errors.invalidFormat">Invalid file format.(allowed only 'pdf', 'jpg', 'jpeg', 'png', 'xls','xlsx')</div>
                    <div *ngIf="icdForm.get('Disability_Form').errors.fileSizeExceeded">Max File size is 5 MB, it exceeds the limit.</div>
                  </div>

                </div>
              </div>
            </div>

          </div>

          <!-- /.card-body -->
        </div>
      </div>


      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>

      <div class="mb-3" *ngIf="btnDisplay">
        <h6>***</h6>
        Upon clicking Submit, an email will be sent to the ICD Owner for confirmation of accuracy.

        <button type="submit" class="btn btn-success float-right">
          {{isLoading ? 'Submit' : 'Submit'}}

        </button>


      </div>
    </form>

  </div>

